import {Box, Stack, Typography} from "@mui/material";
import {IconCoins, IconMoodNervous, IconPhoneCall, IconPill, IconRocket} from "@tabler/icons-react";

export const ProblemStatement = () => {

  return (
    <Stack direction={{xs: "column", md: "row"}} gap={{xs: 2, md: 6}} alignItems={"center"} justifyContent={"center"} useFlexGap flexWrap={"wrap"} sx={{px: {xs: 2, md: 6}, py: {xs: 4, md: 10} }}>
      <Typography fontSize={{xs: "1.2em", md: "1.6em"}} fontWeight={600} color={"secondary"} sx={{width: "100%", pb: 4}} align={"center"}>
        Is Your Contact Center Drowning in Calls?
      </Typography>
      <Stack className={"landing-item"} direction={"column"} gap={2} sx={{maxWidth: "320px", flex: 1}}>
        <Box sx={{color: "primary.dark", pb: 2}}>
          <IconPill size={50} />
        </Box>
        <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Overwhelmed Agents</Typography>
        <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em" }}>
          High call volumes lead to burnout, attrition, and costly training cycles.
        </Typography>
      </Stack>
      <Stack className={"landing-item"} direction={"column"} gap={2} sx={{maxWidth: "320px", flex: 1}}>
        <Box sx={{color: "primary.dark", pb: 2}}>
          <IconMoodNervous size={50} />
        </Box>
        <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Frustrated Customers</Typography>
        <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em" }}>
          Long hold times and repetitive queries damage satisfaction and loyalty.
        </Typography>
      </Stack>
      <Stack className={"landing-item"} direction={"column"} gap={2} sx={{maxWidth: "320px", flex: 1}}>
        <Box sx={{color: "primary.dark", pb: 2}}>
          <IconRocket size={50} />
        </Box>
        <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Skyrocketing Costs</Typography>
        <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em" }}>
          Labor expenses eat into profits, but scaling teams isn’t sustainable.

        </Typography>
      </Stack>
    </Stack>
  )
}